/** @jsxImportSource @emotion/react */
import { TableCell, TableBody, TableRow } from '@coreai/component-library';
import { THeaderProps } from './THeader';
import { css, useTheme } from '@emotion/react';
interface TBodyProps {
    columns: THeaderProps[];
    tableData: any[];
    handleRowClick: (rowData: any, event: React.MouseEvent) => void;
    tableRowClass: string;
}


export default function TBody({columns, tableData, handleRowClick, tableRowClass}: TBodyProps) {
    const theme = useTheme();
    
    const tableRowStyle = () => css`
        cursor: pointer;
        &:hover {
            background-color: ${theme.colors.background};
        }
    `;
  return (
    <TableBody>
        {
            tableData.map((rowData: any, index: number) => {
                return (
                    <TableRow
                        key={rowData.id || index}
                        onClick={(event) => handleRowClick(rowData, event)}
                        css={tableRowStyle}
                        className={tableRowClass || ''}
                    >
                        {columns.map((column: THeaderProps) => {
                            if (!column?.isHidden) {
                                if (typeof column?.renderRowContent === 'function') {
                                    return (
                                        <TableCell className={column?.tdCellClassName || ''}>
                                            {column?.renderRowContent(rowData)}
                                        </TableCell>
                                    );                                    
                                }
                                return (
                                    <TableCell className={column?.tdCellClassName || ''}>
                                        {rowData[column?.key]}
                                    </TableCell>
                                );
                            }
                        })}
                    </TableRow>
                );
            })
        }
    </TableBody>
  )
};